import { ITrangThaiHocSinh } from './../../../models/response/category/ITrangThaiHocSinh';
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { ITrangThaiHocSinhCoSoItemRequest } from '../../../models/response/category/ITrangThaiHocSinhCoSoItemRequest';
import { ITrangThaiHocSinhItemRequest } from '../../../models/response/category/ITrangThaiHocSinhItemRequest';
import { ITrangThaiHocSinhCoSoItemResponse } from '../../../models/response/category/ITrangThaiHocSinhCoSoItemResponse';
export const objTrangThaiHocSinhDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as ITrangThaiHocSinh[],
    LOAD_ERROR: "",

    LOAD_CHECKDANGKY_START: 0,
    LOAD_CHECKDANGKY_SUCCESS: [] as ITrangThaiHocSinhCoSoItemResponse[],
    LOAD_CHECKDANGKY_ERROR: "",

    LOAD_COSO_START: 0,
    LOAD_COSO_SUCCESS: [] as ITrangThaiHocSinh[],
    LOAD_COSO_ERROR: "",

    SHOW_EDIT_MODAL: {} as ITrangThaiHocSinh | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as ITrangThaiHocSinh,
    SAVE_SUCESS: {} as ITrangThaiHocSinh,
    SAVE_ERROR: "",

    // INSERT_START: {} as ITrangThaiHocSinh,
    // INSERT_SUCCESS: {} as ITrangThaiHocSinh,
    // INSERT_ERROR: "",

    INSERT_MULTIPLE_START: {} as ITrangThaiHocSinhCoSoItemRequest,
    INSERT_MULTIPLE_SUCCESS: {} as ITrangThaiHocSinhCoSoItemRequest,
    INSERT_MULTIPLE_ERROR: "",

    UPDATE_START: {} as ITrangThaiHocSinh,
    UPDATE_SUCCESS: {} as ITrangThaiHocSinh,
    UPDATE_ERROR: "",

    UPDATE_THU_TU_START: {} as ITrangThaiHocSinhItemRequest,
    UPDATE_THU_TU_SUCCESS: {} as ITrangThaiHocSinhItemRequest,
    UPDATE_THU_TU_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

};

export const eTrangThaiHocSinhActionTypeIds = generateActionTypeIds(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH")
export type ITrangThaiHocSinhActionTypes = IGenericActionType<typeof objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH">
